export default class QraphQlQuery {

    static getAllUnlistedVendor = (parentEIN, metaData, search) => {
        return this.cdcEmployeeQuery(undefined, metaData, {...search, parentCompanyFilterValue: parentEIN}, [`srctyp: "Vendor"`]);
    };

    static cdcEmployeeQuery = (userId, metaData, search, optionalParams) => {
        const isFrequentVendor = search?.userTypeFilterValue === 'Frequent Vendor';
        const einPrefix = isFrequentVendor ? 'FRQ_' : '';

        const params = optionalParams ? optionalParams : [];

        if (search?.topLeftSearchBy === 'Email address'){
            params.push(`email: "${search.topLeftSearchBoxValue}"`);
        }

        if (search?.topLeftSearchBy === 'Last name'){
            params.push(`lastnm: "${search.topLeftSearchBoxValue}"`);
        }

        if (search?.parentCompanyFilterValue){
            params.push(`prntein: "${einPrefix}${search?.parentCompanyFilterValue}"`);
        }

        if (search?.statusFilterValue){
            params.push(`status: "${search?.statusFilterValue}"`);
        }
        
        const metaParams = [];

        metaParams.push(`offset: ${metaData?.offset || 0}`);
        metaParams.push(`pagesize: ${metaData?.limit || 12}`);
        metaParams.push(`sortBy: "${metaData?.sortKey || "lastnm"}"`);
        metaParams.push(`orderBy: "${metaData?.sortValue || "asc"}"`);

        const query = {
            query: `query {
                prflDtlByPrflGuidInputCount(
                    prflDtlByPrflGuidCountQueryInput: {
                        ${params.join(",")}
                    }
                ) {
                    totalRecords
                }

                prflDtlByPrflGuidInput(
                    prflDtlByPrflGuidQueryInput: {
                        ${[...params, ...metaParams].join(",")}
                    }
                ) {
                    list {
                        bsnsphn
                        city
                        prflcrtdts
                        usrid
                        prfllasteditedts
                        addrline1
                        addrline2
                        srctyp
                        homephn
                        prfllasteditedby
                        cnty
                        prflcrtdby
                        prflinactvtts
                        zip
                        ste
                        prflactvtdts
                        loadts
                        mbilephn
                        prflinactvtby
                        prflguid
                        frstnm
                        lastnm
                        midnm
                        email
                        prflrole
                        status
                        prntcmpnynm
                        prntein
                        prntcmpnylglenttyid
                        usbrltnshp
                    }
                }
            }`,
            variables: null,
            operationName: null
        };

        return query;
    };

    static customerQuery = (userId, metaData, search, parentEin) => {
        if (search && search.topLeftSearchBy) {
            return this.cdcEmployeeQuery(userId, metaData, search, [`prntein:"${parentEin}"`]);
        }
        if (userId && search) {
            return this.cdcEmployeeQuery(userId, metaData, search, [`usrid: "${userId}"`]);
        }
        else if (parentEin && search && search.userTypeFilterValue !== 'Frequent Vendor') {
            return this.cdcEmployeeQuery(userId, metaData, search,  [`prntein:"${parentEin}"`]);
        } else if (parentEin && search && search.userTypeFilterValue === 'Frequent Vendor') {
            return this.cdcEmployeeQuery(userId, metaData, search, [`prntein:"FRQ_${parentEin}"`]);
        }
        else if (userId) {
            return this.cdcEmployeeQuery(userId, metaData, search, [`usrid: "${userId}"`]);
        }
        else if (parentEin) {
            return this.cdcEmployeeQuery(userId, metaData, search, [`prntein:"${parentEin}"`]);
        }
    };
  
    static frequentVendorQuery = (userId, metaData, search, parentEin) => {
        if (search && search.topLeftSearchBy) {
            return this.cdcEmployeeQuery(userId, metaData, search, [`prntein:"${parentEin}"`]);
        } else if (search && search.userTypeFilterValue === 'Frequent Vendor') {
            return this.cdcEmployeeQuery(userId, metaData, search);
        }
        return this.cdcEmployeeQuery(userId, metaData, search,[`prntein:"${parentEin}"`]);
    };

    static getProfile = (profileId) => {
        return this.cdcEmployeeQuery(undefined, undefined, undefined, [`prflguid: "${profileId}"`]);
    };

    static getProfileByUserId = (userId) => {
        return this.cdcEmployeeQuery(userId, undefined, undefined, [`usrid: "${userId}"`]);
    };

    static getCurrentUserRole = (userId) => {
        return { "query": `{\n      getProfileWithParentComType(userID:\"${userId}\") {\n        firstName\n        lastName\n        middleName\n        email\n        businessProfileID\n        profileID\n     \t\tuserID\n    \t\tparentCompanyName\n    \t\tparentCompanyLegalEntityID\n       \tprofileRole\n      \tbusinessProfileID\n    \t\tbusinessProfileType\n    \t\tein\n    \t\ttotal\n        parentEIN\n      }\n    }`, "variables": null, "operationName": null }
    };

    static getCountryQuery = () => {
        return { "query": "{\n      getCountryStateList(nullID:\"\") {\n        countryInfo {\n          countryName\n          countryCode\n        }\n\t\tcountryStateSelection {\n\t\t  stateCode\n\t\t  stateName\n\t\t  }\n      }\n    }", "variables": null, "operationName": null }
    }

    static getVendorList = () => {
        return {"query":`query{bsnsPrflByBsnsEinInput(bsnsPrflByBsnsEinQueryInput:{typ:"Vendor"}){
                        list{
                        bsnsguid
                        bsnsemail
                        zip
                        bsnsphn
                        prntcmpnylglenttyid
                        city
                        ste
                        frstnm
                        typ
                        lastnm
                        loadts
                        prntcmpnynm
                        addrline1
                        addrline2
                        midnm
                        bsnsein
                        cnty
                        typ
                        }
                        }
                        }`,
            variables: null,
            operationName: null
        }
    };

    static getSpecialVendorList = () => {
        return { "query": `
                query {
                    bsnsPrflByBsnsEinInput(
                        bsnsPrflByBsnsEinQueryInput: {typ:"SpecialVendor"}
                    ) {
                        list {
                            bsnsguid
                            bsnsemail
                            zip
                            bsnsphn
                            prntcmpnylglenttyid
                            city
                            ste
                            frstnm
                            typ
                            lastnm
                            loadts
                            prntcmpnynm
                            addrline1
                            addrline2
                            midnm
                            bsnsein
                            cnty
                        }
                    }
                }`, 
            variables: null, 
            operationName: null 
        }
    };

    static isFreqVendorAssociationExists = (userID, parentEIN) => {
        return this.cdcEmployeeQuery(userID, undefined, undefined, [`prntein: "${parentEIN}"`, `usrid: "${userID}"`]);
    };

    static getProfileListWithEmail = (emailID) => {
        return this.cdcEmployeeQuery(undefined, undefined, undefined, [`email: "${emailID}"`]);
    };

    static getExcelReport = (parentEIN) => {
        return { "query": `{\n  getManageUserExcelReport(parentEIN:"${parentEIN}")\n  \n}`, "variables": null, "operationName": null };
    };
        
  }
